/**
 * Created by karora on 11/03/17.
 */
import 'rxjs/add/operator/switchMap';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { WebService } from '../services/web.service';
import { LeadDetails } from '../types/leads';
import {ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';

import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css'],
  providers: [WebService],
})

export class Update implements OnInit {

  selectedFile: any = null;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  matcher = new MyErrorStateMatcher();

  signupdetails = new LeadDetails();
  errorMessage: string;

  constructor(
    private web: WebService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    try {
      this.route.params.subscribe((params: Params) => {
        this.web.getSignUps(params['hash']).subscribe(
          (SignUpDetails: any) => { 
            this.signupdetails = SignUpDetails[0]
            this.emailFormControl.setValue(this.signupdetails.email);   
          },
          (error: any) => this.errorMessage = <any>error,
        );   
      });
    } catch (e) {
      console.log('Error: ' + e);
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  goToScreen(url: string): void {
    this.router.navigate(['/'+ url]);
  }

  submit() {

    if(this.selectedFile){

      this.signupdetails.email = this.emailFormControl.value;
  
      this.signupdetails.image = this.selectedFile;

      this.web.updateSignUp(this.signupdetails).subscribe(
        (response) => {
          console.log(response);
          this.goToScreen("success");
        },
        (error) => {
          console.log(error);
          this.goToScreen("fail")
        } 
      );
    }
  }

  getRequiredErrorMessage() {
    return 'Required Field';
  }

  getBase64(event: any) {
    let that = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      that.selectedFile = reader.result;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
}
